import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetMeasureType {
  message: string;
  result: [
    {
      ID: number;
      TYPE_NAME: string;
    }
  ]
  success: boolean;
}

interface resCreateMeasure {
  message: string;
  result:
  {
    MEASURE_ID: string;
  }

  success: boolean;
}

interface resCreateDetailMeasureByType {
  message: string;
  result: {
    CREATE_DATE: string;
    MEASURE_ID: string;
    NUMBER: string;
    TYPE: string;
    VALUE: string;
  }
  success: boolean;
}

interface resGetDetailMeasureById {
  message: string;
  result: [
    {
      ALWAYS_OPEN: string;
      COIN: number;
      DESCRIPTION: string;
      FONT: string;
      CREATE_DATE: Date;
      IMAGE_MEASURE: string;
      IMAGE_ORIGANAL: string;
      IS_VIEW: number;
      LANGUAGE: string;
      LINK: string;
      MEASURE_END: string;
      MEASURE_ID: string;
      MEASURE_NAME: string;
      MEASURE_START: string;
      MEASURE_TYPE: string;
      QUESTION: string;
      STATUS_MEASURE: number;
      STATUS_PUBLIC: string;
      SUGGESTION_COURSE: string;
      TIME_MEASURE_AGAIN: number;
      IS_SHARE_MEASURE: number;
      ACCESS_VIEW: number;
      INFORMANT_TAG: string;
      IS_MULTI_INFORMANT: number;
      IS_SHOW_INFORMANT_PARTICIPANT_REPORT: number;
      LN_TAG: any;
      details: [{
        ID: number;
        CREATE_DATE: string;
        MEASURE_ID: string;
        NUMBER: string;
        TYPE: string;
        VALUE: [{
          choices: [{
            choice_detail: string;
            choice_id: number;
            media: {
              file_name: string;
              media_type: string;
              file_url: string;
            }
          }],
          media: string;
          file_name: string;
          media_type: string;
          time_again: number;
          unlimit: boolean;
        }],
        question: string;
        type: string;
      }];
    }
  ]
  success: boolean;
}

interface resEditMeasureQuestionByType {
  message: string;
  result: {
    TYPE: string;
    UPDATE_DATE: Date;
    VALUE: string;
  }
  success: boolean;
}

interface resSaveMeasure {
  message: string;
  result: {
    update: Date;
  }
  success: boolean;
}

interface resGetAllDashboardMeasure {
  message: string;
  result: {
  }
  success: boolean;
}

interface resUpdateMeasureStatus {
  success: boolean,
  message: string,
}

interface resDuplicateMeasureByID {
  message: string;
  result: {
    MEASURE_ID: string,
    MEASURE_NAME: string,
  }
  success: boolean;
}

interface resUpdateStatusViewMeasureById {
  message: string;
  result: {
    update: Date;
  }
  success: boolean;
}

interface resGetActiveMeasure {
  message: string;
  result: [
    {
      MEASURE_ID: string;
      MEASURE_NAME: string;
    }
  ]
  success: boolean;
}

interface resExportMeasureById {
  message: string;
  result: [
    {
      DATA: Object;
      DATE: Date;
      MEASURE_ID: string;
      MEASURE_NAME: string;
      USERNAME: string;
      USER_ID: string;
      IS_INFORMANT: string;
      PARTICIPANT_FROM: string;
    }
  ]
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MeasureManagementService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getMeasureType() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetMeasureType>(environment.URL + '/manage_admin/getMeasureType', { headers: headers });
  }

  createMeasure(form) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;
    let suggestCourse = [];
    let informantTag = [];

    if (form.courseSuggest.length > 0)
      for (let i = 0; i < form.courseSuggest.length; i++) {
        suggestCourse.push({
          COURSE_ID: form.courseSuggest[i].COURSE_ID,
          COURSE_NAME: form.courseSuggest[i].COURSE_NAME
        })
      }

    if (form.alwaysOpen) {
      // รอแก้ API ต้องเปลี่ยน dateStart, dateEnd เป็น ''
      formData.append('MEASURE_START', new Date().toDateString().slice(0, 10));
      formData.append('MEASURE_END', new Date().toDateString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'true');
    } else {
      formData.append('MEASURE_START', form.date[0].toLocaleString().slice(0, 10));
      formData.append('MEASURE_END', form.date[1].toLocaleString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'false');
    }
    if (form.measureImg) {
      formData.append('MEASURE_IMG', form.measureImg);
    }

    if (form.informant_tag.length > 0) {
      for (let i = 0; i < form.informant_tag.length; i++) {
        informantTag.push(form.informant_tag[i]);
      }
    }

    formData.append('LANGUAGE', form.language);
    formData.append('STATUS_PUBLIC', form.status);
    formData.append('FONT', form.font);
    formData.append('MEASURE_TYPE', form.type);
    formData.append('MEASURE_NAME', form.name);
    formData.append('DESCRIPTION', form.description);
    formData.append('COIN', form.coin);
    formData.append('SUGGESTION_COURSE', JSON.stringify(suggestCourse));
    formData.append('TIME_MEASURE_AGAIN', form.timeMeasureAgain);

    console.log(form.informant_tag);

    formData.append('IS_MULTI_INFORMANT', form.multi_informant ? '1' : '0');
    formData.append('INFORMANT_TAG', JSON.stringify(informantTag));
    formData.append('IS_SHOW_INFORMANT_PARTICIPANT_REPORT', form.showInformant ? '1' : '0');
    
    return this.http.post<resCreateMeasure>(environment.URL + '/manage_admin/createMeasure', formData, { headers: headers });
  }

  getDetailMeasureById(id) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetDetailMeasureById>(environment.URL + '/manage_admin/getDetailMeasureById?MEASURE_ID=' + id, { headers: headers });
  }

  createDetailMeasureByType(form, data) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;

    // console.log(data);
    // console.log(form);

    if (data.choicesMedia?.length > 0) {
      for (let i = 0; i < data.choicesMedia.length; i++) {
        formData.append('IMG_CHOICES', data.choicesMedia[i]);
      }
    }

    if (data.questionMedia) {
      formData.append('IMG_QUESTION', data.questionMedia);
    }

    formData.append('MEASURE_ID', data.measure_id);
    formData.append('TYPE', form.type);
    formData.append('VALUE', JSON.stringify([form]));

    return this.http.post<resCreateDetailMeasureByType>(environment.URL + '/manage_admin/createDetailMeasureByType', formData, { headers: headers });
  }

  createDetailMeasureByTypeInformant(form, data, valueInformant) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;

    if (data.choicesMedia?.length > 0) {
      for (let i = 0; i < data.choicesMedia.length; i++) {
        formData.append('IMG_CHOICES', data.choicesMedia[i]);
      }
    }

    if (data.questionMedia) {
      formData.append('IMG_QUESTION', data.questionMedia);
    }

    formData.append('MEASURE_ID', data.measure_id);
    formData.append('TYPE', form.type);
    formData.append('VALUE', JSON.stringify([form]));

    formData.append('VALUE_INFORMANT', JSON.stringify(valueInformant))

    return this.http.post<resCreateDetailMeasureByType>(environment.URL + '/manage_admin/createDetailMeasureByType', formData, { headers: headers });
  }

  editMeasureQuestionByType(form, data) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;
    // console.log(form);
    // console.log(data);

    if (data.choicesMedia?.length > 0) {
      for (let i = 0; i < data.choicesMedia.length; i++) {
        formData.append('IMG_CHOICES', data.choicesMedia[i]);
      }
    }

    if (data.questionMedia) {
      formData.append('IMG_QUESTION', data.questionMedia);
    }

    formData.append('ID', data.id)
    formData.append('MEASURE_ID', data.measure_id);
    formData.append('TYPE', form.type);
    formData.append('VALUE', JSON.stringify([form]));

    return this.http.post<resEditMeasureQuestionByType>(environment.URL + '/manage_admin/editMeasureQuestionByType', formData, { headers: headers });
  }

  editMeasureQuestionInformantByType(form, data, valueInformant) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;

    if (data.choicesMedia?.length > 0) {
      for (let i = 0; i < data.choicesMedia.length; i++) {
        formData.append('IMG_CHOICES', data.choicesMedia[i]);
      }
    }

    if (data.questionMedia) {
      formData.append('IMG_QUESTION', data.questionMedia);
    }

    formData.append('ID', data.id)
    formData.append('MEASURE_ID', data.measure_id);
    formData.append('TYPE', form.type);
    formData.append('VALUE', JSON.stringify([form]));

    formData.append('VALUE_INFORMANT', JSON.stringify(valueInformant))
    return this.http.post<resEditMeasureQuestionByType>(environment.URL + '/manage_admin/editMeasureQuestionByType', formData, { headers: headers });
  }

  saveMeasure(form, type, id, questionDeleted) {
    const headers = new HttpHeaders({ Authorization: this.token });
    let formData = new FormData;
    let suggestCourse = [];
    let informantTag = [];

    if (form.courseSuggest.length > 0) {
      for (let i = 0; i < form.courseSuggest.length; i++) {
        suggestCourse.push({
          COURSE_ID: form.courseSuggest[i].COURSE_ID,
          COURSE_NAME: form.courseSuggest[i].COURSE_NAME
        })
      }
    }

    if (form.alwaysOpen) {
      // รอแก้ API ต้องเปลี่ยน dateStart, dateEnd เป็น ''
      formData.append('MEASURE_START', new Date().toDateString().slice(0, 10));
      formData.append('MEASURE_END', new Date().toDateString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'true');
    } else {
      formData.append('MEASURE_START', form.date[0].toLocaleString().slice(0, 10));
      formData.append('MEASURE_END', form.date[1].toLocaleString().slice(0, 10));
      formData.append('ALWAYS_OPEN', 'false');
    }

    if (form.measureImg && form.imgEdit) {
      formData.append('MEASURE_IMG', form.measureImg);
    }

    if (form.informant_tag.length > 0) {
      for (let i = 0; i < form.informant_tag.length; i++) {
        informantTag.push(form.informant_tag[i]);
      }
    }

    console.log(informantTag)

    formData.append('MEASURE_ID', id);
    formData.append('TYPE', type);
    formData.append('LANGUAGE', form.language);
    formData.append('STATUS_PUBLIC', form.status);
    formData.append('FONT', form.font);
    formData.append('MEASURE_TYPE', form.type);
    formData.append('MEASURE_NAME', form.name);
    formData.append('DESCRIPTION', form.description);
    formData.append('COIN', form.coin);
    formData.append('SUGGESTION_COURSE', JSON.stringify(suggestCourse));
    formData.append('TIME_MEASURE_AGAIN', form.timeMeasureAgain);
    formData.append('IMG_EDIT', form.imgEdit.toString());
    formData.append('DELETE_QUESTIONS', JSON.stringify(questionDeleted));

    formData.append('IS_MULTI_INFORMANT', form.multi_informant ? '1' : '0');
    formData.append('INFORMANT_TAG', JSON.stringify(informantTag));
    formData.append('IS_SHOW_INFORMANT_PARTICIPANT_REPORT', form.showInformant ? '1' : '0');

    if (form.centerId) {
      if (form.centerId.length > 0) {
        for (let i = 0; i < form.centerId.length; i++) {
          const el = form.centerId[i];
          formData.append(`LN_TAG[${i}][CENTER_ID]`, el.CENTER_ID);
          formData.append(`LN_TAG[${i}][CENTER_NAME]`, el.CENTER_NAME);
        }
      }
    }

    return this.http.post<resSaveMeasure>(environment.URL + '/manage_admin/saveMeasure', formData, { headers: headers });
  }

  updateStatusMeasure(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resUpdateMeasureStatus>(environment.URL + '/manage_admin/updateStatusMeasure', body, { headers: headers });
  }

  dupplicateMeasureById(mid) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resDuplicateMeasureByID>(environment.URL + '/manage_admin/dupplicateMeasureById', mid, { headers: headers });
  }

  delMeasureById(mid) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resUpdateMeasureStatus>(environment.URL + '/manage_admin/delMeasureById', mid, { headers: headers });
  }

  getAllDashboardMeasure() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetAllDashboardMeasure>(environment.URL + '/manage_admin/getAllDashboardMeasure', { headers: headers });
  }

  updateStatusViewMeasureById(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resUpdateStatusViewMeasureById>(environment.URL + '/manage_admin/updateStatusViewMeasureById', body, { headers: headers });
  }

  getActiveMeasure() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetActiveMeasure>(environment.URL + '/manage_admin/getActiveMeasure', { headers: headers });
  }

  exportMeasureById(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resExportMeasureById>(environment.URL + '/manage_admin/exportMeasureById', body, { headers: headers });
  }

}
